export const settingsTranslations = {
  en: {
    language: "Language Preference",
    notifications: "Notification Preferences",
    admin_control: "Admin Control",
    privacy: "Privacy Settings",
    about: "About",
    terms: "Terms & Conditions",
    select_language: "Select Language",
    language_description: "Select your preferred language for the application interface.",
    current_language: "Current Language",
    language_code: "Language code",
    language_tip: "Language changes are applied immediately to all translated pages.",
    countries: "Countries",
    select_countries: "Select countries",
    regions: "Regions",
    select_regions: "Select regions",
    notification_type: "Notification Type",
    email_notification: "Email Notification",
    push_notification: "Push Notification",
    save_notifications: "Save Notification Settings",
    settings_title: "Settings",
    settings_description: "Manage your account preferences and application settings.",
    under_development: "This section is under development",
    validation_failed: "Validation failed",
    missing_profile_setting_id: "Missing profile setting ID",
    language_update_success: "Language updated successfully",
    language_update_failed: "Failed to update language",
    notifications_save_success: "Notification settings saved successfully",
    notifications_save_failed: "Failed to save settings",
    failed_load_countries: "Failed to load countries",
    failed_load_regions: "Failed to load regions",
    at_least_one_country: "At least one country is required",
    at_least_one_region: "At least one region is required",
    card_publish_description: "Triggered when a card is published.",
    deal_propose_description: "Notifies when a deal is proposed.",
    deal_confirm_description: "Notifies when a deal is confirmed.",
    contact_invite_description: "Triggered when someone invites you to connect.",
    contact_accept_description: "Notifies when someone accepts your contact requestirono.",
    activation_required:"Activation Required"
  },
  de: {
    language: "Spracheinstellungen",
    notifications: "Benachrichtigungseinstellungen",
    admin_control:  "Admin-Steuerung",
    privacy: "Datenschutzeinstellungen",
    about: "Über",
    terms: "Nutzungsbedingungen",
    select_language: "Sprache auswählen",
    language_description: "Wählen Sie Ihre bevorzugte Sprache für die Benutzeroberfläche aus.",
    current_language: "Aktuelle Sprache",
    language_code: "Sprachcode",
    language_tip: "Sprachänderungen werden sofort auf alle übersetzten Seiten angewendet.",
    countries: "Länder",
    select_countries: "Länder auswählen",
    regions: "Regionen",
    select_regions: "Regionen auswählen",
    notification_type: "Benachrichtigungstyp",
    email_notification: "E-Mail-Benachrichtigung",
    push_notification: "Push-Benachrichtigung",
    save_notifications: "Benachrichtigungseinstellungen speichern",
    settings_title: "Einstellungen",
    settings_description: "Verwalten Sie Ihre Kontoeinstellungen und Anwendungseinstellungen.",
    under_development: "Dieser Abschnitt ist in Entwicklung",
    validation_failed: "Validierung fehlgeschlagen",
    missing_profile_setting_id: "Fehlende Profil-Einstellungs-ID",
    language_update_success: "Sprache erfolgreich aktualisiert",
    language_update_failed: "Sprache konnte nicht aktualisiert werden",
    notifications_save_success: "Benachrichtigungseinstellungen erfolgreich gespeichert",
    notifications_save_failed: "Einstellungen konnten nicht gespeichert werden",
    failed_load_countries: "Länder konnten nicht geladen werden",
    failed_load_regions: "Regionen konnten nicht geladen werden",
    at_least_one_country: "Mindestens ein Land ist erforderlich",
    at_least_one_region: "Mindestens eine Region ist erforderlich",
    card_publish_description: "Wird ausgelöst, wenn eine Karte veröffentlicht wird.",
    deal_propose_description: "Benachrichtigt, wenn ein Deal vorgeschlagen wird.",
    deal_confirm_description: "Benachrichtigt, wenn ein Deal bestätigt wird.",
    contact_invite_description: "Wird ausgelöst, wenn jemand Sie zum Verbinden einlädt.",
    contact_accept_description: "Benachrichtigt, wenn jemand Ihre Kontaktanfrage annimmt.",
    activation_required: "Aktivierung erforderlich",
  },
  hr: {
    language: "Postavke jezika",
    notifications: "Postavke obavijesti",
    admin_control: "Administratorska kontrola",
    privacy: "Postavke privatnosti",
    about: "O nama",
    terms: "Uvjeti i odredbe",
    select_language: "Odaberite jezik",
    language_description: "Odaberite željeni jezik za korisničko sučelje aplikacije.",
    current_language: "Trenutni jezik",
    language_code: "Kod jezika",
    language_tip: "Promjene jezika odmah se primjenjuju na sve prevedene stranice.",
    countries: "Države",
    select_countries: "Odaberite države",
    regions: "Regije",
    select_regions: "Odaberite regije",
    notification_type: "Vrsta obavijesti",
    email_notification: "E-mail obavijest",
    push_notification: "Push obavijest",
    save_notifications: "Spremi postavke obavijesti",
    settings_title: "Postavke",
    settings_description: "Upravljajte postavkama svog računa i aplikacije.",
    under_development: "Ovaj odjeljak je u izradi",
    validation_failed: "Provjera valjanosti nije uspjela",
    missing_profile_setting_id: "Nedostaje ID postavke profila",
    language_update_success: "Jezik je uspješno ažuriran",
    language_update_failed: "Ažuriranje jezika nije uspjelo",
    notifications_save_success: "Postavke obavijesti uspješno spremljene",
    notifications_save_failed: "Spremanje postavki nije uspjelo",
    failed_load_countries: "Učitavanje država nije uspjelo",
    failed_load_regions: "Učitavanje regija nije uspjelo",
    at_least_one_country: "Potrebna je barem jedna država",
    at_least_one_region: "Potrebna je barem jedna regija",
    card_publish_description: "Pokreće se kada se kartica objavi.",
    deal_propose_description: "Obavještava kada se predloži posao.",
    deal_confirm_description: "Obavještava kada je posao potvrđen.",
    contact_invite_description: "Pokreće se kada vas netko pozove na povezivanje.",
    contact_accept_description: "Obavještava kada netko prihvati vaš zahtjev za kontakt.",
    activation_required: "Potrebna je aktivacija", 
  },
};